import { KeyRound, Plug, UserRound } from "lucide-mui";
import Box from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { Outlet } from "react-router-dom";
import NavTabs, { type NavTab } from "../../components/NavTabs.tsx";
import PageHeader from "../../components/PageHeader.tsx";
import { useAuth } from "../../contexts/AuthContext.tsx";

const TABS: NavTab[] = [
  { label: "Profile", to: "/account/profile", icon: <UserRound /> },
  { label: "Security", to: "/account/security", icon: <KeyRound /> },
  { label: "Connected apps", to: "/account/apps", icon: <Plug /> },
];

/** Your own account: one header, then each page its own link. On a desktop the
 *  sidebar's section column lists the pages, so the tabs show only on a phone. */
export default function AccountLayout() {
  const { user } = useAuth();
  const isMobile = useMediaQuery(useTheme().breakpoints.down("md"));
  return (
    <Box sx={{ maxWidth: 880 }}>
      <PageHeader
        title="Account"
        description={`Your profile, how you sign in and the apps you've connected · ${user?.email ?? ""}`}
      />
      {isMobile && <NavTabs tabs={TABS} label="Account sections" />}
      <Outlet />
    </Box>
  );
}
